<script setup lang="ts">
import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useRolesStore } from "@/stores/roles";
import { utc2local } from "@/utils";

const roles = useRolesStore();

const { csRoles, loading } = storeToRefs(roles);
onMounted(async () => {
  await roles.refresh();
});

const saveRole = async (email: string, role: string, active: boolean) => {
  return roles.updateRole(email, role, active);
};
</script>

<template>
  <h1>CS account list</h1>
  <pn-spinner size="2" v-show="loading" />
  <pn-table bordered="true" v-show="!loading" striped="true">
    <table>
      <thead>
        <tr>
          <th>Email</th>
          <th>Role</th>
          <th>Last login</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="role in csRoles"
          :key="role.email"
          :class="{ isDisabled: !role.active }"
        >
          <td>
            {{ role.email }}
          </td>
          <td>
            {{ role.role }}
          </td>
          <td>{{ utc2local(role.lastLogin) }}</td>
          <td>
            <pn-button
              v-show="role.active"
              @click="
                saveRole(role.email, role.role, false);
                role.active = false;
              "
              small="true"
              appearance="light"
            >
              Disable
            </pn-button>
            <pn-button
              v-show="!role.active"
              @click="
                saveRole(role.email, role.role, true);
                role.active = true;
              "
              small="true"
              appearance="light"
            >
              Enable
            </pn-button>
          </td>
        </tr>
      </tbody>
    </table>
  </pn-table>
</template>
<style lang="scss" scoped>
.isDisabled > td {
  text-decoration: line-through;
  background: #ddd !important;
}
</style>
